import { Assignment } from "src/@types/user";
import { RoleEnum } from "src/enum/role";
import type { RouteAccessRequirement, UserAccessContext, UserWithPermissions } from "@/@types/tab-navigation";
import type { UserPermissionGroup } from "@/@types/user";

export const checkPermission = ({
  userRole,
  requiredAction,
  assignments,
  requiredRole,
}: {
  userRole: RoleEnum[];
  requiredAction: string[];
  assignments: Assignment[];
  requiredRole: RoleEnum[];
}): boolean => {
  const hasRequiredRole = requiredRole.some((role) => userRole?.includes(role));

  const hasRequiredAssignments =
    requiredAction.length === 0 ||
    assignments.every((assignment) =>
      requiredRole.includes(assignment.assignment as RoleEnum)
    );

  return hasRequiredRole && hasRequiredAssignments;
};

export const hasRouteAccess = (
  requirement: RouteAccessRequirement,
  context: UserAccessContext,
): boolean => {
  const hasAllGroups: boolean = requirement.groupRequired.every((group: string) =>
    context.userGroups.includes(group)
  );
  if (!hasAllGroups) return false;

  return checkPermission({
    userRole: context.userRole,
    requiredAction: requirement.requiredAction,
    assignments: context.assignments,
    requiredRole: requirement.requiredRole,
  });
};

export const buildAccessContext = (
  user: UserWithPermissions | null,
  module: string | null,
): UserAccessContext => {
  const permissions: UserPermissionGroup[] = user?.user_permission_group ?? [];
  const moduleGroup: UserPermissionGroup | undefined = permissions.find(
    (permission: UserPermissionGroup) => permission.group === module,
  );

  return {
    userGroups: permissions.map((permission: UserPermissionGroup) => permission.group),
    userRole: moduleGroup?.role ?? [],
    assignments: moduleGroup?.assignments ?? [],
  };
};
